/**
 * Правила пользования и политика конфиденциальности.
 *
 * Тексты лежат в shared, а не в разметке: на них ссылается и сайт, и бот, и
 * административная панель, а расходиться они не должны. Структура нарочно
 * простая — заголовок, абзацы, при необходимости перечисление: документы
 * читают с телефона, и вложенная иерархия там только мешает.
 *
 * Дата изменения проставляется руками: она сообщает читателю, что документ
 * пересматривали, и обновлять её при правке опечатки незачем.
 *
 * Изложение официальное: это документ, определяющий условия оказания услуги, а
 * не пояснительная записка. Разговорные обороты здесь неуместны — на такой
 * текст ссылаются в споре.
 */
const UPDATED_AT = '8 августа 2026 года';
const SERVICE = 'ghostly.im';
const CONTACT = 'hello@ghostly.im';
export const TERMS = {
    slug: 'terms',
    title: 'Правила пользования',
    updatedAt: UPDATED_AT,
    intro: `Настоящие Правила определяют условия использования сервиса анонимного общения ${SERVICE} (далее — Сервис) и являются публичной офертой. Начало использования Сервиса означает полное и безоговорочное согласие с настоящими Правилами.`,
    sections: [
        {
            title: '1. Термины и общие положения',
            paragraphs: [
                'Сервис — программный комплекс, обеспечивающий анонимное текстовое и голосовое общение между случайно подобранными пользователями, доступный через веб-сайт и мини-приложение в мессенджере Telegram.',
                'Администрация — лицо, осуществляющее управление Сервисом и его техническую поддержку.',
                'Пользователь — физическое лицо, использующее Сервис на условиях настоящих Правил.',
                'Собеседник получает сведения о Пользователе исключительно в объёме условного прозвища, присваиваемого Сервисом на время диалога. Имя, номер телефона, адрес электронной почты и имя пользователя в мессенджере Telegram Собеседнику не передаются.',
            ],
        },
        {
            title: '2. Требования к Пользователю',
            paragraphs: [
                'Сервис предназначен исключительно для лиц, достигших восемнадцатилетнего возраста. Начиная использование Сервиса, Пользователь подтверждает своё соответствие данному требованию.',
                'При выявлении признаков того, что Собеседник не достиг совершеннолетия, Пользователю надлежит прекратить диалог и направить жалобу средствами Сервиса.',
            ],
        },
        {
            title: '3. Порядок доступа к Сервису',
            paragraphs: [
                'Использование Сервиса возможно без прохождения авторизации. В этом случае функциональные возможности ограничены: диалоги не сохраняются, доступ к завершённым диалогам не предоставляется.',
                'Авторизация через мессенджер Telegram предоставляет расширенные возможности: сохранение диалогов, добавление Собеседника в список сохранённых контактов и возобновление общения впоследствии. В мини-приложении авторизация выполняется автоматически.',
                'Учётная запись предназначена для использования одним лицом. Передача доступа третьим лицам, его отчуждение, а равно использование чужой учётной записи не допускаются.',
            ],
        },
        {
            title: '4. Обязанности Пользователя',
            paragraphs: [
                'При использовании Сервиса Пользователю запрещается:',
            ],
            items: [
                'вести с несовершеннолетними общение интимного характера, осуществлять их целенаправленный поиск либо склонять их к каким-либо действиям;',
                'направлять материалы порнографического характера, а равно любые изображения с участием несовершеннолетних;',
                'допускать оскорбления, угрозы, преследование, а также высказывания, направленные на разжигание вражды по любому признаку;',
                'распространять рекламные сообщения, приглашения в сторонние каналы и сообщества, ссылки на иные ресурсы, а равно осуществлять рассылку сообщений массового характера;',
                'совершать действия, направленные на введение Собеседника в заблуждение, получение от него денежных средств либо имущественной выгоды;',
                'предлагать к обороту товары и вещества, оборот которых ограничен или запрещён законодательством;',
                'собирать, сохранять и распространять сведения о Собеседнике, включая изображения экрана, содержание переписки и присланные файлы;',
                'выдавать себя за представителя Администрации;',
                'использовать программные средства автоматизации, обходить установленные ограничения, а равно совершать действия, нарушающие работоспособность Сервиса.',
            ],
        },
        {
            title: '5. Материалы, направляемые Пользователем',
            paragraphs: [
                'Ответственность за содержание направляемых изображений и голосовых сообщений несёт направивший их Пользователь.',
                'Пользователю следует учитывать, что Собеседник имеет техническую возможность сохранить полученные материалы. Администрация не располагает средствами предотвращения таких действий и не отвечает за последующее использование материалов Собеседником.',
            ],
        },
        {
            title: '6. Жалобы и меры реагирования',
            paragraphs: [
                'Пользователь вправе направить жалобу на действия Собеседника средствами Сервиса. При направлении жалобы диалог завершается, а материалы, необходимые для её рассмотрения, передаются модератору.',
                'По результатам рассмотрения к Пользователю, допустившему нарушение, могут быть применены предупреждение либо ограничение доступа к Сервису на определённый срок или бессрочно. При поступлении значительного числа жалоб ограничение доступа применяется автоматически с последующей проверкой модератором.',
                'Направление заведомо необоснованных жалоб является нарушением настоящих Правил.',
            ],
        },
        {
            title: '7. Сохранённые диалоги',
            paragraphs: [
                'Каждый из участников диалога вправе предложить его сохранение. При получении согласия второго участника диалог становится доступен обоим в соответствующем разделе Сервиса.',
                'Объём сведений, доступных Собеседнику, при этом не изменяется и ограничивается условным прозвищем.',
                'Исключение Собеседника из числа сохранённых контактов влечёт удаление диалога у обоих участников без возможности восстановления.',
            ],
        },
        {
            title: '8. Обращения по техническим вопросам',
            paragraphs: [
                'Пользователь вправе направить Администрации сообщение о выявленной технической неисправности средствами Сервиса. К обращению прилагаются технические сведения об устройстве и версии приложения, необходимые для устранения неисправности. Содержание переписки в состав таких сведений не входит.',
            ],
        },
        {
            title: '9. Ограничения использования',
            paragraphs: [
                'Администрация вправе устанавливать количественные ограничения на отправку сообщений, подбор Собеседников и загрузку файлов в целях противодействия злоупотреблениям.',
                'Сервис может быть временно недоступен в связи с проведением технических работ. Администрация не гарантирует бесперебойность его работы.',
            ],
        },
        {
            title: '10. Ответственность',
            paragraphs: [
                'Содержание сообщений определяется Пользователями самостоятельно. Администрация не осуществляет предварительный просмотр переписки и не вмешивается в диалоги при отсутствии жалобы.',
                'Сервис предоставляется на условиях «как есть». Администрация не несёт ответственности за действия Собеседников, за использование ими полученных сведений, а равно за последствия достигнутых Пользователями договорённостей.',
            ],
        },
        {
            title: '11. Прекращение доступа',
            paragraphs: [
                'Администрация вправе ограничить либо прекратить доступ Пользователя к Сервису при нарушении настоящих Правил, а также при совершении действий, создающих угрозу безопасности иных Пользователей или работоспособности Сервиса.',
                `Возражения относительно применённых мер направляются по адресу ${CONTACT} с изложением обстоятельств.`,
            ],
        },
        {
            title: '12. Изменение Правил',
            paragraphs: [
                'Администрация вправе вносить изменения в настоящие Правила. Дата последней редакции указана в начале документа. Продолжение использования Сервиса после внесения изменений означает согласие с новой редакцией.',
            ],
        },
    ],
};
export const PRIVACY = {
    slug: 'privacy',
    title: 'Политика конфиденциальности',
    updatedAt: UPDATED_AT,
    intro: `Настоящая Политика определяет порядок обработки сведений, получаемых при использовании сервиса анонимного общения ${SERVICE} (далее — Сервис), и применяется совместно с Правилами пользования.`,
    sections: [
        {
            title: '1. Основные принципы',
            paragraphs: [
                'Обработка сведений осуществляется в объёме, необходимом для подбора Собеседника, обеспечения обмена сообщениями и рассмотрения жалоб.',
                'Собеседнику не передаются сведения, позволяющие идентифицировать Пользователя. Объём доступных ему данных ограничивается условным прозвищем, присваиваемым Сервисом.',
            ],
        },
        {
            title: '2. Состав обрабатываемых сведений',
            items: [
                'при авторизации через мессенджер Telegram — идентификатор учётной записи, имя, имя пользователя, язык интерфейса и изображение профиля в объёме, предоставленном мессенджером;',
                'при использовании Сервиса без авторизации — произвольный идентификатор, сохраняемый в браузере Пользователя;',
                'сведения, указанные Пользователем при настройке поиска: пол, возраст, тема общения и предпочтения в отношении Собеседника;',
                'технические сведения: сетевой адрес подключения, данные о браузере и устройстве, дата последнего использования Сервиса;',
                'сообщения, направляемые в ходе диалога, — в объёме, необходимом для их доставки и отображения участникам;',
                'сведения, содержащиеся в обращениях по техническим вопросам.',
            ],
        },
        {
            title: '3. Цели обработки',
            items: [
                'подбор Собеседника в соответствии с указанными Пользователем параметрами;',
                'обеспечение обмена сообщениями между участниками диалога;',
                'рассмотрение жалоб и применение мер, предусмотренных Правилами пользования;',
                'противодействие злоупотреблениям, автоматизированным обращениям и обходу применённых ограничений;',
                'обеспечение доступа к сохранённым диалогам;',
                'направление уведомлений при наличии соответствующего согласия Пользователя;',
                'устранение технических неисправностей.',
            ],
        },
        {
            title: '4. Сведения, доступные Собеседнику',
            paragraphs: [
                'Собеседнику доступны условное прозвище, признак нахождения Пользователя в Сервисе и содержание сообщений, направленных ему Пользователем. Иные сведения, включая имя пользователя в мессенджере, номер телефона и сетевой адрес, Собеседнику не предоставляются.',
            ],
        },
        {
            title: '5. Сроки обработки',
            items: [
                'сведения, связанные с завершёнными диалогами, обрабатываются в течение срока, определяемого Администрацией, после чего подлежат удалению;',
                'сохранённые диалоги остаются доступными участникам до исключения Собеседника из числа сохранённых контактов; такое исключение влечёт удаление диалога у обоих участников;',
                'материалы, необходимые для рассмотрения поступившей жалобы, обрабатываются в течение срока, требуемого для её рассмотрения и применения мер реагирования;',
                'сведения об учётной записи обрабатываются в течение срока её использования;',
                'обращения по техническим вопросам обрабатываются до устранения неисправности.',
            ],
        },
        {
            title: '6. Передача сведений третьим лицам',
            paragraphs: [
                'Обработка отдельных категорий сведений может осуществляться с привлечением лиц, обеспечивающих функционирование Сервиса:',
            ],
            items: [
                'поставщика услуг размещения оборудования и программного обеспечения;',
                'поставщика услуг хранения файлов, направляемых Пользователями;',
                'мессенджера Telegram — при авторизации и направлении уведомлений;',
                'систем веб-аналитики и рекламных систем на веб-сайте — в объёме обезличенных сведений о посещениях; в мини-приложении указанные системы не используются.',
            ],
            // Формулировка нарочно общая: конкретные основания перечислять незачем,
            // а обязанность соблюдать закон существует независимо от документа.
        },
        {
            title: '7. Файлы cookie и локальное хранилище',
            paragraphs: [
                'В браузере Пользователя сохраняются сведения, необходимые для поддержания сессии, идентификации при повторном обращении и хранения выбранных настроек.',
                'На веб-сайте применяются системы веб-аналитики и рекламные системы, использующие собственные файлы cookie. Отказ от их использования осуществляется средствами браузера и не влияет на возможность общения.',
            ],
        },
        {
            title: '8. Меры защиты',
            paragraphs: [
                'Передача данных между Пользователем и Сервисом осуществляется по защищённому соединению. Доступ к сведениям ограничен кругом уполномоченных лиц, действия которых фиксируются в журнале.',
            ],
        },
        {
            title: '9. Права Пользователя',
            paragraphs: [
                `Пользователь вправе запросить сведения об обрабатываемых данных, потребовать удаления учётной записи либо отозвать согласие на обработку, направив обращение по адресу ${CONTACT}.`,
                'Отдельные сведения, необходимые для исполнения обязанностей Администрации, в том числе связанные с рассмотренными жалобами и применёнными ограничениями, сохраняются и после удаления учётной записи.',
            ],
        },
        {
            title: '10. Обработка сведений несовершеннолетних',
            paragraphs: [
                'Сервис не предназначен для лиц, не достигших восемнадцатилетнего возраста, и не осуществляет намеренный сбор их данных. При выявлении такой учётной записи она подлежит удалению.',
            ],
        },
        {
            title: '11. Изменение Политики',
            paragraphs: [
                'Администрация вправе вносить изменения в настоящую Политику. Дата последней редакции указана в начале документа.',
            ],
        },
    ],
};
export const LEGAL_DOCUMENTS = [TERMS, PRIVACY];
//# sourceMappingURL=documents.js.map